import HttpRequest from "@/api/axios";
import moment from 'moment';
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    getItemSubs: function (data) {
        return axios
            .request({
                url: `mwap/compareinfo`,
                method: 'get',
                params: data,
            })
            .then((res) => {
                if (+res.status === 200) {
                    let sys_time = res.sys_time;
                    let {list} = res.data;
                    res.data.canjoin = '';
                    list.forEach((item) => {

                        item.start_time_show = moment(item.start_time * 1000).format(
                            'MM月DD日 HH:mm'
                        );
                        item.end_time_show = moment(item.end_time * 1000).format(
                            'MM月DD日 HH:mm'
                        );
                        item.start_time_week = moment(item.start_time * 1000).format(
                            'dd'
                        );
                        item.start_time_day = moment(item.start_time * 1000).format(
                            'DD'
                        );
                        if (!item.attended && sys_time >= item.start_time * 1 && sys_time <= item.end_time * 1) {
                            res.data.canjoin = item;
                        }
                        if(sys_time < item.start_time){
                            item.state_title = '未开始'
                            item.state = 0;
                        }else if(sys_time > item.end_time){
                            item.state_title = '已结束'
                            item.state= 2;
                        }else{
                            item.state_title = '进行中'
                            item.state=1;
                        }

                    });
                }
                return res;
            });
    },
    getComparegame: function (data) {
        return axios
            .request({
                url: `mwap/comparegame`,
                method: 'post',
                data,
            })
            .then((r) => {
                return r;
            });
    },
    submitCompare(data) {
        return axios.request({
            url: 'mwap/submitcompare',
            method: 'post',
            data,
        });
    },
    compareRank(params) {
        return axios.request({
            url: 'mwap/comparerank',
            method: 'get',
            params,
        });
    },
    compareRank2(params) {
        return axios.request({
            url: 'mwap/comparerank2',
            method: 'get',
            params,
        });
    },
    compareRankAll(params) {
        return axios.request({
            url: 'mwap/compare-rank-all',
            method: 'get',
            params,
        });
    },
    compareGroupRank(params) {
        return axios.request({
            url: 'mwap/while-group-rank',
            method: 'get',
            params,
        });
    },
    sportsItemRank(params) {
        return axios.request({
            url: 'mwap/sports-item-rank',
            method: 'get',
            params,
        });
    },
    myRanks(params) {
        return axios.request({
            url: 'mwap/my-attend',
            method: 'get',
            params,
        });
    },
    vote(params) {
        return axios.request({
            url: `mwap/vote`,
            method: 'post',
            data: params
        });
    },
    getVoteDetail(params) {
        return axios.request({
            url: `mwap/get-vote-detail`,
            method: 'get',
            params
        });
    },
    addXYInfo: (data) => {
        return axios.request({
            url:`matchregister/add-xingye-s`,
            method: 'post',
            data,            
        });
      },
    // 
}